import { authService } from '../services/authService';

interface UserData {
  userId?: string;
  user: string;
  handler: string;
  nick?: string;
  email: string;
  sistema_origen?: string;
  planeta_origen?: string;
  admin: boolean;
  capitan?: boolean;
  alias?: string[];
  reputacion_corvus?: number;
  reputacion_stars?: number;
  organizaciones?: Array<{
    _id: string;
    id: string;
    tag: string;
    name: string;
    rol: string;
    fecha_ingreso: string;
    fecha_abandono: string | null;
  }>;
  iat?: number;
  exp?: number;
}

export const useAuth = () => {
  const getToken = (): string | null => {
    // Leer corvus_token directamente de sessionStorage
    return sessionStorage.getItem('corvus_token');
  };

  const getUserData = (): UserData | null => {
    // Leer user_data de sessionStorage (guardado por corvusnocta.org)
    const userDataStr = sessionStorage.getItem('user_data');
    if (!userDataStr) {
      // Si no hay user_data, intentar decodificar el token
      const token = getToken();
      if (!token) return null;

      try {
        const payload = token.split('.')[1];
        const decodedData = JSON.parse(atob(payload));
        return decodedData;
      } catch (error) {
        return null;
      }
    }

    try {
      return JSON.parse(userDataStr);
    } catch (error) {
      return null;
    }
  };

  const logout = () => {
    // Usar el logout del authService que redirige a starmap
    authService.logout();
  };

  const isAuthenticated = (): boolean => {
    return !!getToken();
  };

  return {
    getToken,
    getUserData,
    isAuthenticated,
    logout
  };
}; 